import { useGetUserNameWithFallback } from '@pba/react-utils';
import { useTranslation } from 'react-i18next';
import { Text } from 'ui';

type P = {
  invitee: { firstName?: string; id: string; lastName?: string };
  viewerId: string;
};

const EventInviteeName = ({ invitee, viewerId }: P) => {
  const { t } = useTranslation();

  const getUserNameWithFallback = useGetUserNameWithFallback();

  return (
    <Text type="title" weight="medium">
      {invitee.id === viewerId
        ? t('listUserName', { name: getUserNameWithFallback(invitee) })
        : getUserNameWithFallback(invitee)}
    </Text>
  );
};

export default EventInviteeName;
